export default __webpack_public_path__ + "static/assets/med_pill_round_out_L1_solid_x_01_f.25c779b3.png";